webpackJsonp([71],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedirectToUrl = function (_Component) {
    _inherits(RedirectToUrl, _Component);

    function RedirectToUrl() {
        _classCallCheck(this, RedirectToUrl);

        return _possibleConstructorReturn(this, (RedirectToUrl.__proto__ || Object.getPrototypeOf(RedirectToUrl)).apply(this, arguments));
    }

    _createClass(RedirectToUrl, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.location.replace(this.props.redirectUrl);
        }
    }, {
        key: 'render',
        value: function render() {
            return '';
        }
    }]);

    return RedirectToUrl;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var url = _ref.url;
    return _react2.default.createElement(RedirectToUrl, { redirectUrl: url });
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/components/RedirectToUrl.jsx.7f8e2d9d.js